import useApi from 'common/hooks/useApi';
import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import GroupDetailsResponse from './GroupDetailsResponse';
import GroupDetails from './GroupDetails';

export const GroupDetailsContext = React.createContext({
  onRefresh: () => console.warn('Refresh has not been initialized'),
});

function GroupDetailsContainer() {
  const {
    params: { groupKey },
  } = useRouteMatch<{ groupKey: string }>();

  const [res, request] = useApi<GroupDetailsResponse>({
    url: `/applications/groups/${groupKey}`,
    method: 'GET',
  });

  useEffect(() => {
    request();
  }, [request]);

  return (
    <>
      <GroupDetailsContext.Provider value={{ onRefresh: request }}>
        {res.data && (
          <GroupDetails groupDetails={res.data} onRefresh={request} />
        )}
      </GroupDetailsContext.Provider>
    </>
  );
}

export default GroupDetailsContainer;
